<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="产品名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
              <el-form-item label="产品分类：">
                <el-select v-model="searchForm.type" clearable>
                   <el-option value="5" label="烟杆"></el-option>
                    <el-option value="6" label="烟弹"></el-option>
                    <el-option value="12" label="手提袋"></el-option>
                    <el-option value="13" label="展盒"></el-option>
                    <el-option value="14" label="抽台"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="产品系列：">
                <el-select v-model="searchForm.times" clearable>
                   <el-option value="9" label="畅刻二代系列"></el-option>
                    <el-option value="10" label="悦刻五代系列"></el-option>
                    <el-option value="11" label="畅刻五代系列"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgGroupListPageHandle">搜索</el-button>
                <el-button type="primary" @click="showAddPkgGroup">新建分类</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="name" label="产品名称"></el-table-column> 
            <el-table-column prop="typeName" label="产品分类"></el-table-column>  
               <el-table-column prop="timesName" label="产品系列"></el-table-column>  
            <el-table-column prop="createTime" label="创建时间"></el-table-column> 
            <el-table-column prop="stateName" label="状态"></el-table-column> 
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
                </template>    
            </el-table-column> 
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
                <el-form-item label="名称：" prop="name">
                    <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
                </el-form-item>    
                <el-form-item label="是否禁用：" prop="state">
                      <el-select v-model="addOrEditGroupForm.state" placeholder="请选择">
                        <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>   
                <el-form-item label="所属类别：" prop="type">
                      <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
                        <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>    
                <el-form-item label="所属系列：" prop="times">
                      <el-select v-model="addOrEditGroupForm.times" placeholder="请选择">
                        <el-option v-for="item in timesOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>    
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtGroupHandle">确 定</el-button>
            </div>            
        </el-dialog>  
    </div>
</template>
<script>
import {getPkgGroupListPage,addPkgGroup,updatePkgGroup,changePkgGroupState, getPkgIsMonthOption,updateSmokeState,insertSmoke,updateSmoke,getsmokeListPage} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                name: '',
                type:'',
                times:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,                
            },            
            addOrEditGroupForm: {
                name: '',
                type: '',
                isNextMonth: '',
                supplierType: '',
                id:'',
                state:'',
                times:''
            },
            currentId: '',
            addFlag: null,
            addGroupVisibale: false,
            title: '',
            pkgTypeOption: [],
            supplierOption: [
                 {
                    code:5,
                    description:'烟杆'
                },
                 {
                    code:6,
                    description:'烟弹'
                },
                 {
                    code:12,
                    description:'手提袋'
                },
                 {
                    code:13,
                    description:'展盒'
                },
                 {
                    code:14,
                    description:'抽台'
                }
            ],
            timesOption:[
             {
                    code:9,
                    description:'畅刻二代系列'
                },
                 {
                    code:10,
                    description:'悦刻五代系列'
                },
                 {
                    code:11,
                    description:'畅刻五代系列'
                }
                   
            ],
            isMonthOption: [
                {
                    code:7,
                    description:'上架'
                },
                 {
                    code:8,
                    description:'下架'
                }
            ],
            addOrEditGroupRules: {
                name: [{required: true, message: '请输入套餐名称', trigger: 'blur'}],
                type: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                isNextMonth: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                supplierType: [{required: true, message: '请选择套餐名称', trigger: 'change'}]
            }
        }
    },
    methods: {
        cancel(){
            this.addGroupVisibale = false;      
            this.$refs.addOrEditGroupForm.resetFields();    
        },   
        showbtnText(state){
            return common.showTxtByState(state, {0: '启用', 1: '禁用'})
        },
        getPkgGroupListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getsmokeListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            }) 
        },
        showAddPkgGroup(){
            this.addGroupVisibale = true;
            this.addFlag = true;
            this.title = "增加分类";             
            this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
        },
        showEditPkgGroup(row){
            this.addGroupVisibale = true;
            this.addFlag = false;
            this.title = "修改分类";
            this.addOrEditGroupForm.name = row.name;
             this.addOrEditGroupForm.times = row.times;
            this.addOrEditGroupForm.type = row.type;
            this.addOrEditGroupForm.state = row.state;
            this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
            this.addOrEditGroupForm.supplierType = row.supplierType;
            this.currentId = row.id; 
        },
        addOrEidtGroupHandle(){
            this.$refs.addOrEditGroupForm.validate(valid => {
                if(valid) {
                    var data = this.addOrEditGroupForm;
                    if(this.addFlag == true){
                        insertSmoke(data).then(res => callback(res))
                    }else{
                        data.id = this.currentId
                        updateSmoke(data).then(res => callback(res))               
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgGroupListPageHandle();
                        _this.addGroupVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            }) 
        },
        changeStateHandle(id){
            var data = {
                id
            }
            changePkgGroupState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getPkgGroupListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })           
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgGroupListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getPkgGroupListPageHandle();
        }  
    },
    created () {
        this.getPkgGroupListPageHandle();
       
    }    
}
</script>
<style>

</style>
